import "babel-polyfill"
import Element from "element-ui"
import "element-ui/lib/theme-chalk/index.css"
import locale from "element-ui/lib/locale/lang/en"
import "@/assets/css/bootstrap.css"
import "@/assets/css/public.css"
import Vue from "vue"
import App from "@/App.vue"
import i18n from "@/configs/lang"
import { global } from "@/configs/global"
import router from "@/configs/router"
import { store } from "@/store/store"
import "@/plugins/element.js"
import Bowser from "bowser"
import { api } from "@/utils/api"

Vue.use(Element, { locale })

Vue.config.productionTip = false
Vue.prototype.$global = global

store.state.Browser = Bowser.getParser(window.navigator.userAgent).getBrowser()
sessionStorage.setItem("Accept-Language", i18n.locale)
store.dispatch("setLanguage", i18n.locale)

api
  .apiGetCodeCultures()
  .then((response) => {
    if (response.data) {
      store.dispatch("setCodeCulture", response.data)
    }
  })
  .catch((error) => {
    console.log(error)
  })

new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App),
}).$mount("#app")
